<div class="preview-template-wrapper">
  <form [formGroup]="rform" (ngSubmit)="onSubmit()" autocomplete="off">
    <div mat-dialog-content class="preview-template-wrapper__content">
      <div
        class="left"
        *ngIf="
          data.headerAmount > 0 ||
          data.bodyAmount > 0 ||
          (headerType && headerType !== 'TEXT')
        ">
        <div class="title title--section">
          Cree un ejemplo del uso de esta plantilla; el mismo será usado para ayudar
          a los usuarios al momento de enviarla.
        </div>

        <div class="parameters-section">
          <div
            class="parameters-section__title-wrapper"
            *ngIf="
              (headerType && headerType !== 'TEXT') ||
              (headerType === 'TEXT' && data.headerAmount > 0)
            ">
            <h4 class="parameters-section__title">Encabezado / Header</h4>
            <span
              class="badge badge--info"
              *ngIf="headerType && headerType !== 'TEXT'"
              >Media &rarr; {{ headerMediaType[headerType]['name'] }} ({{
                headerMediaType[headerType]['label']
              }})</span
            >
          </div>

          <ng-container *ngIf="headerType && headerType !== 'TEXT'">
            <div
              *ngIf="
                headerType === 'IMAGE' ||
                headerType === 'DOCUMENT' ||
                headerType === 'VIDEO'
              ">
              <input
                formControlName="headerMediaValue"
                type="file"
                style="display: none"
                (change)="
                  fileSelected(
                    $event,
                    headerType === 'IMAGE'
                      ? 'img'
                      : headerType === 'DOCUMENT'
                        ? 'document'
                        : 'video'
                  )
                "
                readonly
                [accept]="
                  headerType === 'IMAGE'
                    ? 'image/png, image/jpeg'
                    : headerType === 'DOCUMENT'
                      ? '.pdf'
                      : 'video/mp4, video/mpeg, video/ogg'
                "
                #fileInput />
              <button
                mat-raised-button
                color="accent"
                (click)="fileInput.click()"
                type="button"
                aria-label="Send message"
                style="margin-top: 20px">
                SELECCIONAR ARCHIVO
              </button>
              <button
                class="send-file-button"
                mat-icon-button
                type="button"
                aria-label="Send message"
                (click)="clearFileSelected()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="(headerType === 'TEXT' || !headerType) && data.headerAmount > 0">
            <div
              class="parameters-section__message__wrapper"
              [ngClass]="{ 'message-error': f.get('headerText').errors?.maxlength }">
              <p
                class="parameters-section__message"
                [innerHTML]="data.headerText"></p>
              <div class="parameters-section__footer">
                <div
                  class="parameters-section__footer__msg-error"
                  *ngIf="f.get('headerText').errors?.maxlength">
                  Este campo no puede tener más de {{ maxLengthHeader }} caracteres.
                </div>
                <div class="parameters-section__footer__msg-count">
                  {{ calculateLengthOfField('headerText') }}
                  / {{ maxLengthHeader }}
                </div>
              </div>
            </div>

            <mat-form-field floatLabel="never">
              <input
                matInput
                formControlName="headerParameter"
                placeholder="Ingrese datos para la variable {{ 1 }}"
                (input)="exampleInputChangeHandler('header', 0)"
                required />
              <mat-error
                *ngIf="
                  f.get('headerParameter').invalid ||
                  f.get('headerParameter').touched
                ">
                <span *ngIf="f.get('headerParameter').errors?.required">{{
                  getErrorMessage()
                }}</span>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>

        <div class="parameters-section" *ngIf="data.bodyAmount > 0">
          <h4 class="parameters-section__title">Cuerpo / Body</h4>
          <div
            class="parameters-section__message__wrapper"
            [ngClass]="{ 'message-error': f.get('bodyText').errors?.maxlengthBad }">
            <p
              class="parameters-section__message parameters-section__message--body"
              [innerHTML]="data.bodyText"></p>
            <div class="parameters-section__footer">
              <div
                class="parameters-section__footer__msg-error"
                *ngIf="f.get('bodyText').errors?.maxlengthBad">
                Este campo no puede tener más de {{ maxLengthBody }} caracteres.
              </div>
              <div class="parameters-section__footer__msg-count">
                {{ calculateLengthOfField('bodyText') }} / {{ maxLengthBody }}
              </div>
            </div>
          </div>

          <ng-container
            formArrayName="bodyParameters"
            *ngFor="let bodyParameter of getBodyParamatersArr(); let i = index">
            <mat-form-field floatLabel="never">
              <input
                type="text"
                matInput
                [formControlName]="i"
                placeholder="Ingrese datos para la variable {{ i + 1 }}"
                required
                (input)="exampleInputChangeHandler('body', i)" />
              <mat-error *ngIf="bodyParameter.invalid || bodyParameter.touched">
                <span *ngIf="bodyParameter.errors?.required">{{
                  getErrorMessage()
                }}</span>
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <div
        class="right preview-template"
        [ngClass]="{
          full:
            data.headerAmount === 0 &&
            data.bodyAmount === 0 &&
            (!headerType || headerType === 'TEXT')
        }">
        <div class="preview-template__wrapper">
          <div class="title title--preview-template">Vista previa</div>
          <div class="preview-template__content">
            <preview-template
              [template]="template"
              [styleNameCustom]="'customStyle1'"></preview-template>
          </div>

          <!-- TODO: esta valición se reemplazo
                    <div *ngIf="f.get('headerText').invalid || f.get('bodyText').invalid"
                        class="invalid-parameters-data">
                        <span *ngIf="f.get('headerText').errors?.maxlength"
                            class="invalid-parameters-data__item"><span>&#8226; Encabezado / Header:</span> no
                            puede tener más de <span>{{maxLengthHeader}}</span> caracteres.</span>
                        <span *ngIf="f.get('bodyText').errors?.maxlength"
                            class="invalid-parameters-data__item"><span>&#8226; Cuerpo / Body:</span> no puede tener más
                            de
                            <span>{{maxLengthBody}}</span> caracteres.</span>
                    </div> -->
        </div>

        <div class="preview-template__wrapper" *ngIf="data.action === 'send'">
          <div class="title title--preview-template">Ejemplo</div>
          <div class="preview-template__content">
            <preview-template
              [template]="templateWithExamples"
              [styleNameCustom]="'customStyle1'"></preview-template>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="preview-template-wrapper__actions">
      <button
        mat-raised-button
        type="button"
        aria-label="cancel"
        style="background-color: #2d323e; color: white"
        (click)="matDialogRef.close()">
        {{ 'CANCEL' | translate }}
      </button>

      <button
        mat-raised-button
        type="submit"
        class="submit-button"
        color="accent"
        aria-label="SAVE"
        [disabled]="f.invalid || urlHeaderInitCheck">
        {{ (data.action === 'send' ? 'SEND' : 'TEMPLATE.SEND') | translate }}
      </button>
    </div>
  </form>
</div>
